import { Progress, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { UploadDocumentStore } from '@/stores/local/sidebar/UploadDocumentStore';

import s from './UploadProgress.module.scss';

type UploadProgressProps = {
  store: UploadDocumentStore;
};

const UploadProgress: React.FC<UploadProgressProps> = ({ store }) => {
  if (!store.meta.isLoading) {
    return null;
  }

  return (
    <div className={s.root}>
      <Text size="sm">
        Загружено {store.uploadCompleted} из {store.uploadTotal}
      </Text>
      <Progress value={store.uploadProgressPercent} size="sm" />
    </div>
  );
};

export default observer(UploadProgress);
